import {marked} from "marked";
import {LegalPage} from "~/components/legalPage";
import source from "~/content/legal/terms-of-service.md?raw";

const html = marked.parse(source, {async: false});

export function meta() {
    return [{title: "Terms of Service, Intellsys OS"}];
}

export default function RouteComponent() {
    return (
        <LegalPage
            title="Terms of Service"
            html={html}
        />
    );
}
